import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"label":"Grupo de Empresas","placeholder":"Selecione o grupo de empresas","items":_vm.items,"loading":_vm.loading,"readonly":_vm.disabled && _vm.model,"item-text":"description","item-value":"id","rules":_vm.rules,"return-object":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }